import { Auth, CognitoUser } from '@aws-amplify/auth';

export const getAuthToken = async (): Promise<string> => {
  const user: CognitoUser = await Auth.currentAuthenticatedUser();

  return `Bearer ${user.getSignInUserSession().getIdToken().getJwtToken()}`;
};
